import React from 'react';
import { Container, Card } from '@paypalcorp/pp-react';
import TermsContent from './TermsContent';
import { parseMessages } from '../../utilityHelper';
import withTheme from '../../common/withTheme';

const propertyInfo = parseMessages('directmodel/home');

class Terms extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div id="directModelWrapper" className="row">
                <Container className="container">
                    <Card card className="enroll showconsent">
                        <TermsContent propertyInfo={propertyInfo}/>
                    </Card>
                </Container>
            </div>
        );
    }
}
export default withTheme(Terms);